import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Globe, 
  Star, 
  MessageCircle, 
  Quote
} from 'lucide-react';

const TrustedByThousands = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 1,
      nameKey: 'trustedByThousands.testimonials.sarah.name',
      titleKey: 'trustedByThousands.testimonials.sarah.title',
      commentKey: 'trustedByThousands.testimonials.sarah.comment',
      rating: 5,
      avatar: '👩‍💼'
    },
    {
      id: 2,
      nameKey: 'trustedByThousands.testimonials.james.name',
      titleKey: 'trustedByThousands.testimonials.james.title',
      commentKey: 'trustedByThousands.testimonials.james.comment',
      rating: 5,
      avatar: '👨‍💼'
    },
    {
      id: 3,
      nameKey: 'trustedByThousands.testimonials.maria.name',
      titleKey: 'trustedByThousands.testimonials.maria.title',
      commentKey: 'trustedByThousands.testimonials.maria.comment',
      rating: 5,
      avatar: '👩‍💻'
    }
  ];


  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-gradient-to-r from-orange-100 to-red-100 text-orange-600 rounded-full px-6 py-3 text-sm font-semibold mb-6">
            <Globe className="w-4 h-4 mr-2" />
            {t('trustedByThousands.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            {t('trustedByThousands.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('trustedByThousands.subtitle')}
          </p>
        </div>

        {/* Testimonials */}
        <div className="mb-16">
          <div className="flex items-center justify-center gap-2 mb-8">
            <MessageCircle className="w-6 h-6 text-orange-500" />
            <h3 className="text-2xl font-bold text-gray-900">
              {t('trustedByThousands.testimonialsTitle')}
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 relative hover:scale-[1.02] transition-all duration-300"
              >
                {/* Quote icon */}
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center">
                  <Quote className="w-4 h-4 text-white" />
                </div>
                
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                {/* Comment */}
                <blockquote className="text-gray-700 mb-6 italic leading-relaxed">
                  "{t(testimonial.commentKey)}"
                </blockquote>
                
                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-2xl">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{t(testimonial.nameKey)}</div>
                    <div className="text-sm text-gray-600">{t(testimonial.titleKey)}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedByThousands;